import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ras_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("ras_token");
      localStorage.removeItem("ras_user");
      if (window.location.pathname.startsWith("/app")) {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export const extractError = (error, fallback = "Si è verificato un errore") => {
  const d = error?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  return fallback;
};

export default api;
